import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { BeneficioSocial } from 'src/app/core/beneficio-social';
import { BeneficioSocialPessoaFisica } from 'src/app/core/beneficio-social-pessoa-fisica';
import { DataUtilService } from 'src/app/services/commons/data-util.service';

@Component({
  selector: 'beneficio-social-pessoa-fisica-aluno',
  templateUrl: './beneficio-social-pessoa-fisica-aluno.component.html',
  styleUrls: ['./beneficio-social-pessoa-fisica-aluno.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class BeneficioSocialPessoaFisicaAlunoComponent implements OnInit {

  @Input() beneficiosSociaisPessoaFisica: BeneficioSocialPessoaFisica[];
  @Input() beneficio: BeneficioSocialPessoaFisica;
  @Input() index: number;
  @Input() perfilAcesso: Acesso;
  @Input() beneficiosSociais: BeneficioSocial[];
  @Output() calcularValorTotalRenda = new EventEmitter();

  pinBeneficioSocial  = Date.now();
  pinValor            = Date.now();
  pinDataInicio       = Date.now();
  pinDataFim          = Date.now();

  constructor(private dataUtilService: DataUtilService) { }

  ngOnInit(): void {
  }

  deletar() {
    this.beneficiosSociaisPessoaFisica.splice(this.index, 1);
    this.calcularValorRenda();
  }


  carregarDadosBenficioSocial(){
    if (this.beneficio.beneficioSocial.id) {
      this.beneficio.beneficioSocial = _.cloneDeep(_.find(this.beneficiosSociais,  (f: BeneficioSocial) => f.id === this.beneficio.beneficioSocial.id));
    }
  }
  
  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  calcularValorRenda() {
    this.calcularValorTotalRenda.emit();
  }
}
